<template>
  <q-list v-if="phases.length" bordered separator class="rounded-borders">
    <q-item v-for="phase in phases" :key="phase.id"
            :clickable="clickable"
            @click="$emit('click', phase)">
      <q-item-section>
        <div class="row items-center q-col-gutter-x-md">
          <q-item-label class="col-xs-8 col-sm-6">
            {{ phase.title }}
          </q-item-label>
          <div class="col-xs-2 col-sm-3">
            <status-value
                v-if="phase.status"
                :status="$phaseStatusColor(phase.status)"
                :label="$phaseStatusLabel(phase.status)"
                :hide-label="$isMobile"
            />
          </div>
        </div>
      </q-item-section>
      <q-item-section side v-if="showDetails">
        <div class="row items-center">
          <span class="q-mr-sm">
            {{ $formatDateString(phase.pivot.updated_at) }}
          </span>
          <icon-button
              icon="chat_bubble_outline"
              color="neutral-60"
              aria-label="Laat een bericht achter op dit document"
              size="sm"
              round
          />
        </div>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
import { phaseStatusMixin } from '~HIOR/mixins'

export default {
  emits: ['click'],
  mixins: [phaseStatusMixin],
  props: {
    phases: {
      type: Array,
      default: () => [],
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
